import { render, staticRenderFns } from "./Karin-form-modal.vue?vue&type=template&id=0522e80d&scoped=true"
import script from "./Karin-form-modal.vue?vue&type=script&lang=js"
export * from "./Karin-form-modal.vue?vue&type=script&lang=js"
import style0 from "./Karin-form-modal.vue?vue&type=style&index=0&id=0522e80d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0522e80d",
  null
  
)

export default component.exports